import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
// import { DataServiceService } from '../data-service.service';
import { Observable } from 'rxjs/internal/Observable';
import { filter, map, startWith } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { DialogcampusComponent } from '../dialogcampus/dialogcampus.component';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import * as $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4'; // If you're using Bootstrap 4
import { CampusdialogComponent } from '../campusdialog/campusdialog.component';
import { CampusTrackService } from '../campus-track.service';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogComponent } from '../../course-Track/dialog/dialog.component';
@Component({
  selector: 'app-campus-track',
  templateUrl: './campus-track.component.html',
  styleUrls: ['./campus-track.component.scss']
})
export class CampusTrackComponent implements OnInit {
  campusTrack1!: FormGroup;
  campus: any;
  listBy: string = 'PENDING';
  filteredCampus: Observable<string[]>;
  options: any;
  data1: any;
  obj: any;
  classList: any[];
  classWiseStreams: any[];
  classData: any;
  selectedClass: any;
  temp: any[];
  dialogRef: any;
  data: any;
  selectedOptionId: any
  filteredOptions: Observable<any>;
  list: any;
  filterParams: any;


  Campus: any = new FormControl();
  Class1: any = new FormControl();
  Stream1: any = new FormControl()

  campusname: any;
  Class: any;
  Stream: any;

  classNames: any;
  mediums: any;
  group: any;
  selectId: any;
  campusName: any;
  values1: any;
  constructor(private fb: FormBuilder, private course: CampusTrackService, private dialog1: NgDialogAnimationService, private spinner: NgxSpinnerService) { }
  ngOnInit(): void {

    this.campusTrack1 = this.fb.group({
      campusname: ["",Validators.required],
    })

    this.getpending()
    this.getdata()

  }
 
  private Filter(value: string, list: any[], name: string): any[] {
    const searchValue = value.trim().toLocaleLowerCase();
    let filteredList = list.filter((item: any) => item[name] && item[name].trim().toLocaleLowerCase().includes(searchValue));
    return filteredList;
}
  private _filter1(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.Class.filter((option: any) => option.displayName.toLowerCase().includes(filterValue));
  }
  private _filter2(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.Stream.filter((option: any) => option.streamName.toLowerCase().includes(filterValue));
  }


  getdata() {
    this.course.getcampus().subscribe((res: any) => {
      this.options = res;
      this.campus = res;
      this.classNames = this.Campus!.valueChanges.pipe(
        startWith(''),
        map((value:any) => this.Filter(value,this.campus,"campusName")|| '')
      );
      console.log(this.campus);
    })
  }
  getpending() {
    this.spinner.show()
    this.course.getcampuspendinglist(this.listBy).subscribe((res: any) => {
      this.list = res
      this.spinner.hide()
      $(document).ready(() => {
        $('#example1').DataTable({
          scrollX: true ,
          scrollCollapse: true,
          scrollY:"400px",
          ordering: true,
          order:[]
        });
      });
    })
    console.log("pending", this.list);
  }

  opendialog() {
    this.dialogRef = this.dialog1.open(DialogcampusComponent, {
    
      width: "510px",
      height: "100%",
      position: { right: '0' },
      maxWidth: '100%',
      animation: { to: 'left' },
      autoFocus: false,
      disableClose: true,
      // hasBackdrop: false,
      data: this.data1,
    });
    
  this.dialogRef.afterClosed().subscribe((value:any) => {
    
    $('#example1').DataTable().destroy();
   this. getpending()
  })
  }
  pending(filterParams:any ){
    this.values1=this.campusTrack1.value.campusname
    if( this.campusTrack1.valid){
        this.course.getcampuslist(filterParams,this.values1).subscribe((res: any) => {
          this.list = res;
          $('#example1').DataTable().destroy();
          $(document).ready(() => {
            $('#example1').DataTable({
              // columnDefs: [{ width: '20%', targets: 0 }],
              scrollX: true ,
              scrollY:"450px",
              scrollCollapse: true,
              ordering: true,
              order: [] 
            });
          });
         
      })
    
    }else{
    this.course.getcampuspendinglist(filterParams).subscribe((res: any) => {
      this.list = res;
      $('#example1').DataTable().destroy();
      $(document).ready(() => {
        $('#example1').DataTable({
          // columnDefs: [{ width: '20%', targets: 0 }],
          scrollX: true ,
          scrollY:"450px",
          scrollCollapse: true,
          ordering: true,
          order: [] 
        });
      });
     
  });
  }
}
  campusdialog(report: any){
    this.data = report

    this.dialogRef = this.dialog1.open(CampusdialogComponent, {
      width: "510px",
      height: "1000px",
      position: { right: '0' },
      maxWidth: '100%',
      animation: { to: 'left' },
      autoFocus: false,
      disableClose: true,
      data: this.data

    });
    
    this.dialogRef.afterClosed().subscribe((value:any) => {
      if(value == 'REJECTED'){
        this.pending(value)  
      }
      else if(value == 'APPROVED'){
        this.pending(value)
      }else if(value == 'pending'){
        $('#example1').DataTable().destroy();
        this.getpending()
      }
    })
    
  }
  filterCampus(option:any){
    this.selectId = option.campusId
    this.campusName = option.campusName
    // this.dialogdata.setCampusName(option.campusName)
  }

}

